import { ArrowUpRight } from "lucide-react";
import { projects } from "../../mock";

const WorkSection = () => {
  const large = projects.find((p) => p.size === "large");
  const small = projects.filter((p) => p.size === "small");

  return (
    <section className="work" id="work">
      <div className="wrap">
        <div className="section-head reveal">
          <div>
            <div className="kicker">02 — Selected work</div>
            <h2>
              A study in
              <br />
              <span className="accent">proportion.</span>
            </h2>
          </div>
          <p>
            Residential architecture shaped around natural light, refined materials, strong geometry, and the way people actually inhabit space.
          </p>
        </div>

        <div className="work-grid reveal">
          <a href="#contact" className="work-card work-card--large">
            <div className="work-card__image">
              <img src={large.image} alt={large.alt} />
            </div>
            <div className="work-meta">
              <div>
                <span>{large.label}</span>
                <h3>{large.title}</h3>
              </div>
              <ArrowUpRight size={22} strokeWidth={1.25} />
            </div>
          </a>

          <div className="side-stack">
            {small.map((p) => (
              <a key={p.id} href="#contact" className="work-card">
                <div className="work-card__image">
                  <img src={p.image} alt={p.alt} />
                </div>
                <div className="work-meta">
                  <div>
                    <span>{p.label}</span>
                    <h3>{p.title}</h3>
                  </div>
                  <ArrowUpRight size={22} strokeWidth={1.25} />
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorkSection;
